<p-drawer
  #drawerRef
  [(visible)]="visible"
  [closeOnEscape]="false"
  [dismissible]="false"
  position="bottom"
  styleClass="h-auto w-full lg:w-[80vw] xl:w-[60vw] xxl:w-[50vw]">
  <ng-template #headless>
    <div class="relative p-6">
      <div class="font-bold">Polityka plików cookies</div>

      <div class="flex items-center text-sm">
        <div>
          <div>
            Używamy ciasteczek, aby zapewnić najlepszą jakość korzystania z
            naszej witryny.
          </div>

          <div>
            <div class="mr-1 inline-block">
              Aby dowiedzieć się więcej, zapoznaj się z naszą
            </div>

            <app-router-link
              [route]="Route.PL_PrivacyPolicy"
              class="inline-block">
              <div class="hover:text-primary inline-block underline">
                polityką prywatności
              </div>
            </app-router-link>

            <div class="inline-block">.</div>
          </div>
        </div>

        <div class="ml-auto inline-flex gap-3">
          <p-button
            (onClick)="handleCloseClick($event)"
            label="Zamknij"
            variant="outlined" />

          <p-button
            (onClick)="handleAcceptClick($event)"
            label="Akceptuj" />
        </div>
      </div>
    </div>
  </ng-template>
</p-drawer>
